<div class="rpf-modal__body">
  <div class="rpf-modal__header pb-16">
    <button class="rpf-modal__close-btn"
            (click)="closeModal(false)"
    >
      <mat-icon [svgIcon]="eSvgIcons.CLOSE_THIN"></mat-icon>
    </button>
  </div>

  <div class="rpf-modal__content">
    <div class="rpf-modal__content--image">
      <img [attr.src]="data.imageUrl" [attr.alt]="data.title">
    </div>

    <h4 class="title">
      {{ data.title | translate }}
    </h4>

    @if (data.description) {
      <p class="description" [innerHtml]="data.description | translate | safeHtml"></p>
    }
  </div>
</div>
